import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

/**
 * Actions filter for IAM_AWS_PERMISSION relationships.
 * Uses ANY_STARTS_WITH operator to match against the actions array field.
 * Free-text input for AWS IAM action strings (e.g., "sts:AssumeRole", "s3:Get").
 */
export const Actions: SimpleFilterDefinition = {
  apiField: 'actions',
  uiField: 'Actions',
  inputType: 'text',
  operators: ['has'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => ({
    field: 'Actions',
    operator: 'has',
    value: queryFilter.value as string,
  }),

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => ({
    field: 'actions',
    operator: 'ANY_STARTS_WITH',
    value: simpleFilter.value,
    not: false,
  }),
};
